import Partial from './Partial.vue';


export default {
    name: 'PartialRenderer',
    extends: Partial,
    computed: {
        targetEl() {
            return this.target
                ? this.$el.querySelector(this.target)
                    : Array.isArray(this.$slots.default)
                    ? this.$slots.default[0].elm : null;
        }
    },
    methods: {
        emitToVM(...args) {
            this.$vnode.context.$emit(...args);
        },
        captureForm(form) {
            let { action, method } = form;
            form.addEventListener('submit', e => {
                e.preventDefault();

                this.emitToVM('submit', {
                    url: action, method,
                    body: new FormData(form)
                });
            })
        }
    },
    mounted() {
        // force update to trigger componentUpdated event to the directive
        this.$forceUpdate();

        if (this.targetEl instanceof HTMLFormElement) {
            this.captureForm(this.targetEl);
        }
    }
}
